import debounce from "lodash.debounce";
export default {
  name: "app-input",
  props: {
    modelValue: String,
    placeholder: String
  },
  methods: {},
  setup(props, {
    emit
  }) {
    const updateInput = debounce(event => {
      emit("update:modelValue", event.target.value);
    }, 500);
    return {
      updateInput
    };
  }
};